// From https://www.gitmemory.com/issue/intljusticemission/react-big-calendar/1478/538528088

import moment from "./moment";

export const currentTimezone = moment.tz.guess();
/**
 * This will create a 'moment' object that *is* moment.tz(), and automatically use the
 * 'timezone' used when you called 'getMoment()'
 */
export const getMoment = (timezone = currentTimezone) => {
    const m = (...args) => moment.tz(...args, timezone);
    m.localeData = moment.localeData;
    m.min = moment.min;
    m.max = moment.max;
    return m;
};

/**
 * 'datetime' is a JS Date object
 * 'tzMoment is the 'moment' object you got from 'getMoment()'
 */
export const convertDateTimeToDate = (datetime, tzMoment) => {
    return new Date(tzMoment(datetime).format()); // sets Date using ISO 8601 format
};

// *not* using this
export const convertDateToDateTime = (date, timezone) => {
    const m = moment.tz(date, timezone);
    return moment.tz(
        {
            year: m.year(),
            month: m.month(),
            date: m.date(),
            hour: m.hour(),
            minute: m.minute()
        },
        timezone
    );
};

/*
 * 'now' is your 'getNow' method
 * 'tzMoment is the 'moment' object you got from 'getMoment()'
 */
export const getNow = (now, tzMoment) => convertDateTimeToDate(now, tzMoment);

export const dayFormat = (date, culture, localizer) => {
    return localizer.format(date, 'ddd DD/MM/YYYY', culture);
}

export const dateRangeHeaderFormat = ({start, end}, culture, localizer) => {
    return `${localizer.format(start, "ddd, DD/MM/YYYY")} - ${localizer.format(end, "ddd, DD/MM/YYYY")}`;
}

export const agendaRangeHeaderFormat = ({date, length}, culture, localizer) => {
    let endDate = new Date(date);
    endDate.setDate(date.getDate() + length);

    return length > 0 ?
        `${localizer.format(date, "dddd, MMMM DD, YYYY")} - ${localizer.format(endDate, "dddd, MMMM DD, YYYY")}`
        : `${localizer.format(date, "dddd, MMMM DD, YYYY")}`;
}
